<template>
  <v-flex xs12 sm12 lg10 offset-lg1 xl8 offset-xl2 py-3>
    <v-card class="red lighten-2" dark>
      <v-card-title class="headline red lighten-3">
        Search for a Post
      </v-card-title>
      <v-card-text>
        <v-autocomplete
          v-model="selected"
          :items="titles"
          :search-input.sync="search"
          :loading="loading"
          item-text="title"
          item-value="slug"
          label="Search for your favorite post..."
          prepend-icon="fas fa-blog"
          counter
          clearable
          hide-selected
          hide-no-data
          cache-items
          validate-on-blur
          color="white"
        >
        </v-autocomplete>
      </v-card-text>
      <v-divider></v-divider>
      <v-expand-transition>
        <v-list v-if="selected" class="red lighten-3">
          <v-list-tile v-for="(field, i) in fields" :key="i">
            <v-list-tile-content>
              <v-list-tile-title v-text="field.value"></v-list-tile-title>
              <v-list-tile-sub-title v-text="field.key"></v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-expand-transition>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!selected"
          color="red darken-3"
          @click="querySelection(selected)"
        >
          Go to Post
        </v-btn>
        <v-btn
          :disabled="!selected"
          color="grey darken-3"
          @click="selected = null"
        >
          Clear
          <v-icon right>fas fa-times-circle</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: 'AutoComplete',
  props: {
    posts: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      selected: null,
      search: null,
    };
  },
  computed: {
    titles() {
      return this.posts.map((post) => {
        return {
          title: post.title,
          slug: post.slug,
        };
      });
    },
    loading() {
      return this.$store.getters.isLoading;
    },
  },
  methods: {
    querySelection(value) {
      this.$router.push({
        name: 'post',
        params: {
          slug: value,
        },
      });
    },
  },
};
</script>
